import { ReactNode } from "react";

export enum FlagTypes {
  featured = "FEATURED",
  unlock = "UNLOCK",
  review = "REVIEW",
}

export enum OrderDirection {
  Asc = "ASC",
  Desc = "DESC",
}

export enum SearchResultItemOrderField {
  Name = "NAME",
}

export type Obj = { [key in string]: any };

export type TabOption = {
  label: string | ReactNode;
  value: string;
  icon?: ReactNode;
};

export type FieldOption = {
  name: string;
  value: string | string[];
};

export type FilterOption = {
  name: string;
  label?: string;
  type?: "search" | "select";
  value: FieldOption["value"];
  options?: string[];
  multiple?: boolean;
  placeholder?: string;
};

export type ListName = {
  name: string;
};
